// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__37aiM","actions":"GroupTable_actions__1C69X","deleteModalFooter":"GroupTable_deleteModalFooter__2pAkL"};